import React, { useState, useEffect } from "react";
import "./ECommerceComponents.css";
import axios from "axios";
// import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import { security_key, Url } from "../../Services/Api";
import BottomToust from "../../Components/BottomToust/BottomToust";

const PayMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [error, setError] = useState(null);

  async function fetchPaymentMethods() {
    setLoading(true);
    setError(null);
    setTimeout(async () => {
      try {
        const response = await axios.get(`${Url}/api/v1/payment-methods/get-all`);
        const paymentMethods = response.data.paymentMethods || [];
        setPaymentMethods(paymentMethods);
        setToastMessage("Payment Methods have been fetched successfully!");
        setShowMessage(true);
      } catch (error) {
        const errMsg = error?.response?.data?.message || error.message;
        setError(errMsg);
        setToastMessage(`Failed to fetch Payment Methods: ${errMsg}`);
        setShowMessage(true);
      } finally {
        setLoading(false);
      }
    }, 2000);
  }

  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  const handleCloseMessageModal = () => {
    setShowMessage(false);
  };

  useEffect(() => {
    if (showMessage === true) {
      const timeOut = setTimeout(() => {
        setShowMessage(false);
      }, 3000);

      return () => clearTimeout(timeOut);
    }
  }, [showMessage]);

  // const handleToggle = async (method) => {
  //   const updatedStatus = method.activeStatus === 1 ? 0 : 1;

  //   setPaymentMethods((prevMethods) =>
  //     prevMethods.map((item) =>
  //       item.id === method.id ? { ...item, activeStatus: updatedStatus } : item
  //     )
  //   );

  //   const token = sessionStorage.getItem('authToken');
  //   const headers = {
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${token}`,
  //     'x-api-key': security_key
  //   };

  //   try {
  //     const response = await fetch(`${Url}/api/v1/payment-methods/edit-method`, {
  //       method: 'Put',
  //       headers: headers,
  //       body: JSON.stringify({
  //         id: method.id,
  //         activeStatus: updatedStatus,
  //       }),
  //     });

  //     if (!response.ok) {
  //       throw new Error('Failed to update payment method status');
  //     }

  //   } catch (error) {
  //     console.error('Error updating payment method:', error);

  //     setPaymentMethods((prevMethods) =>
  //       prevMethods.map((item) =>
  //         item.id === method.id ? { ...item, activeStatus: method.activeStatus } : item
  //       )
  //     );
  //   }
  // };

const handleToggle = async (method) => {

  // PREVENT DISABLING LAST ACTIVE METHOD
  const activeMethods = paymentMethods.filter(
    (item) => item.activeStatus === 1
  );

  if (
    method.activeStatus === 1 &&
    activeMethods.length === 1
  ) {
    setToastMessage(
      "At least one payment gateway must remain active"
    );

    setShowMessage(true);
    return;
  }

  // IF CURRENT IS OFF -> ENABLE IT
  // AND DISABLE ALL OTHERS
  const updatedMethods = paymentMethods.map((item) => ({
    ...item,
    activeStatus:
      item.id === method.id
        ? 1
        : 0,
  }));

  // UI UPDATE
  setPaymentMethods(updatedMethods);

  const token = sessionStorage.getItem("authToken");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    "x-api-key": security_key,
  };

  try {

    // UPDATE ALL METHODS
    await Promise.all(
      updatedMethods.map(async (item) => {
        await fetch(
          `${Url}/api/v1/payment-methods/edit-method`,
          {
            method: "PUT",
            headers,
            body: JSON.stringify({
              id: item.id,
              activeStatus: item.activeStatus,
            }),
          }
        );
      })
    );

  } catch (error) {

    console.error(
      "Error updating payment methods:",
      error
    );

    // REVERT BACK
    setPaymentMethods(paymentMethods);

    setToastMessage(
      "Failed to update payment methods"
    );

    setShowMessage(true);
  }
};

  const getPayMethodImage = (imagePath) => {
    return imagePath ? `${Url + imagePath}` : "";
  };

  return (
    <>
      <div className="PaymentMethodsMainPage">
        {/* {loading && (
        <div className="backdrop">
          <MainLoader />
        </div>
      )} */}

        <div className="PaySection-01">
          <div className="Row-01">
            <div className="Leftside">
              <div className="MainPayContainer">
                <span className="PayMethods-Header">Payment Gateways</span>
              </div>

              <div className="BodyContainer-PayMethod">
                {loading ? (
                  Array(3).fill().map((_, index) => (
                    <div key={index} className="PaymentMethodShimmerRow">
                      <div style={{ marginLeft: "10px" }}><ShimmerLoader width="60px" height="50px" borderRadius="20%" /></div>
                      <div style={{ marginLeft: "30px" }}> <ShimmerLoader width="230px" height="20px" borderRadius="5px" /></div>
                      <div style={{ marginLeft: "70px" }}> <ShimmerLoader width="60px" height="30px" /></div>
                    </div>
                  ))
                ) : paymentMethods.length === 0 ? (
                  <div className="NoPaymentMethodsMessage">
                    No Payment Methods Selected Yet
                  </div>
                ) : (
                  paymentMethods
                    .slice()
                    .sort((a, b) => a.menu_order - b.menu_order)
                    .map((method) => (
                      <div key={method.id} className="PaymentMethodRow">
                        <img
                          src={getPayMethodImage(method.logo)}
                          className="PaymentMethodImage"
                        />
                        <span className="PaymentMethodName">{method.name}</span>
              <div
  className={`CustomToggle ${
    method.activeStatus === 1
      ? "Enabled"
      : "Disabled"
  }`}
  onClick={() => {
    // ONLY ACTIVE ONE CAN BE CLICKED
    if (method.activeStatus === 1) {
      setToastMessage(
        "At least one payment gateway must remain active"
      );

      setShowMessage(true);
    }
  }}
  style={{
    cursor:
      method.activeStatus === 1
        ? "not-allowed"
        : "not-allowed",
    opacity:
      method.activeStatus === 1
        ? 1
        : 0.5,
  }}
>
  <div className="ToggleCircle"></div>
</div>
                      </div>
                    ))
                )}
              </div>

            </div>
          </div>
        </div>
      </div>
      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={() => handleCloseMessageModal()}
      />
    </>
  );
};

export default PayMethods;